import React, { useContext } from 'react';
import { Container } from 'reactstrap';
import { SuperParentContext, ParentContext } from '../../Container/displayboardcontext';

const ThemeOneDisplayboardContainer: React.FC = () => {
    const context = useContext(SuperParentContext);
    return (
        <Container fluid className="p-0 mdbWrapper mthemeDarkSignage">
            {/* <context.themeOneTopbar /> */}
            <context.themeOneParentManager />
            <context.themeOneFooter />
            <ParentContext.Provider value={context}>
                <context.themeOneAlert />
            </ParentContext.Provider>
        </Container>
    );
}
export default ThemeOneDisplayboardContainer;